"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _MD = _interopRequireDefault(require("../Icons/CheckCircleOutlined/MD"));
var _SM = _interopRequireDefault(require("../Icons/CheckCircleOutlined/SM"));
var _SM2 = _interopRequireDefault(require("../Icons/Cross/SM"));
var _MD2 = _interopRequireDefault(require("../Icons/Info/MD"));
var _SM3 = _interopRequireDefault(require("../Icons/Info/SM"));
var _MD3 = _interopRequireDefault(require("../Icons/Warning/MD"));
var _SM4 = _interopRequireDefault(require("../Icons/Warning/SM"));
var _tss = require("../styles/tss");
var _capitalizeFirstWord = require("../utilities/capitalizeFirstWord");
const _excluded = ["action", "children", "classes", "className", "closeText", "color", "icon", "onClose", "role", "severity", "size"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const getSizeClassKey = size => {
  return `size${(0, _capitalizeFirstWord.capitalizeFirstWord)(size)}`;
};
const useStyles = (0, _tss.makeTssStyles)({
  name: 'DsAlert',
  uniqId: 'MbOz9k'
})((theme, _params, classes) => {
  const {
    styles,
    breakpoints,
    colors,
    spacing,
    typography
  } = theme.busbud;
  const sizeSm = {
    padding: spacing(1, 1.5),
    [`& .${classes.message}`]: _objectSpread(_objectSpread({}, typography.font.component.text.sm), {}, {
      marginLeft: spacing(0.5)
    })
  };
  const sizeMd = {
    padding: spacing(1.5, 2),
    [`& .${classes.message}`]: _objectSpread(_objectSpread({}, typography.font.component.text.md), {}, {
      marginLeft: spacing(1),
      marginTop: spacing(0.25)
    })
  };
  return {
    /* Styles applied to the root element. */
    root: {
      borderRadius: styles.rounding.md,
      backgroundColor: 'transparent',
      display: 'flex',
      alignItems: 'center'
    },
    sizeSm,
    sizeMd,
    sizeResponsive: _objectSpread(_objectSpread({}, sizeSm), {}, {
      [breakpoints.up('md')]: sizeMd
    }),
    /* Styles applied to the root element if `variant="standard"` and `color="positive"`. */
    positive: {
      color: colors.text.positive.opaque,
      backgroundColor: colors.background.positive.transparent,
      [`& .${classes.icon}`]: {
        color: colors.icon.positive.opaque
      },
      [`& .${classes.action}`]: {
        color: colors.text.positive.opaque
      }
    },
    /* Styles applied to the root element if `variant="standard"` and `color="informative"`. */
    informative: {
      color: colors.text.informative.opaque,
      backgroundColor: colors.background.informative.transparent,
      [`& .${classes.icon}`]: {
        color: colors.icon.informative.opaque
      },
      [`& .${classes.action}`]: {
        color: colors.text.informative.opaque
      }
    },
    /* Styles applied to the root element if `variant="standard"` and `color="notice"`. */
    notice: {
      color: colors.text.notice.opaque,
      backgroundColor: colors.background.notice.transparent,
      [`& .${classes.icon}`]: {
        color: colors.icon.notice.opaque
      },
      [`& .${classes.action}`]: {
        color: colors.text.notice.opaque
      }
    },
    /* Styles applied to the root element if `variant="standard"` and `color="negative"`. */
    negative: {
      color: colors.text.negative.opaque,
      backgroundColor: colors.background.negative.transparent,
      [`& .${classes.icon}`]: {
        color: colors.icon.negative.opaque
      },
      [`& .${classes.action}`]: {
        color: colors.text.negative.opaque
      }
    },
    /* Styles applied to the content wrapper element. */
    content: {
      marginLeft: spacing(-0.5),
      marginRight: 'auto',
      display: 'flex',
      alignItems: 'flex-start'
    },
    /* Styles applied to the icon wrapper element. */
    icon: {
      display: 'flex'
    },
    /* Styles applied to the message wrapper element. */
    message: {},
    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: spacing(4),
      marginTop: spacing(-0.5),
      marginBottom: spacing(-0.5)
    },
    hiddenMdUp: {
      [breakpoints.up('md')]: {
        display: 'none'
      }
    },
    hiddenSmDown: {
      [breakpoints.down('sm')]: {
        display: 'none'
      }
    }
  };
});
const defaultIconMapping = {
  sm: {
    positive: /*#__PURE__*/React.createElement(_SM.default, null),
    notice: /*#__PURE__*/React.createElement(_SM4.default, null),
    negative: /*#__PURE__*/React.createElement(_SM4.default, null),
    informative: /*#__PURE__*/React.createElement(_SM3.default, null)
  },
  md: {
    positive: /*#__PURE__*/React.createElement(_MD.default, null),
    notice: /*#__PURE__*/React.createElement(_MD3.default, null),
    negative: /*#__PURE__*/React.createElement(_MD3.default, null),
    informative: /*#__PURE__*/React.createElement(_MD2.default, null)
  }
};
const alertRole = 'alert';
const renderResponsiveIcon = (severity, classes, icon) => {
  // @ts-ignore
  const smIcon = icon ? icon['sm'] || icon : defaultIconMapping['sm'][severity];
  // @ts-ignore
  const mdIcon = icon ? icon['md'] || icon : defaultIconMapping['md'][severity];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(smIcon, {
    className: classes.hiddenMdUp
  }), /*#__PURE__*/React.cloneElement(mdIcon, {
    className: classes.hiddenSmDown
  }));
};

/**
 * **❗️ DEPRECATED**: Use the new `Alert` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/feedback-alert-alert):
 *
 * ```tsx
 * import { Alert } from "@busbud/horizon";
 * ```
 *
 * [Storybook](https://busbud.github.io/horizon-web-ui-kit/?path=/docs/feedback-alert-alert)
 *
 * @deprecated
 */
const Alert = /*#__PURE__*/React.forwardRef(function Alert(props, ref) {
  const {
      action,
      children,
      classes: classesOverrides,
      className,
      closeText = 'Close',
      color,
      icon,
      onClose,
      role = alertRole,
      severity = 'positive',
      size = 'md'
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles(undefined, {
    props: {
      classes: classesOverrides
    }
  });
  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
    role: role || (color || severity) === 'negative' ? alertRole : role,
    className: cx(classes.root, classes[color || severity], classes[getSizeClassKey(size)], className),
    ref: ref
  }, other), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, icon !== false ? /*#__PURE__*/React.createElement("div", {
    className: classes.icon
  }, size === 'responsive' ? renderResponsiveIcon(severity, classes, icon) : icon || defaultIconMapping[size][severity]) : null, /*#__PURE__*/React.createElement("div", {
    className: classes.message
  }, children)), /*#__PURE__*/React.createElement("div", {
    className: classes.action
  }, action, !action && onClose ? /*#__PURE__*/React.createElement(_IconButton.default, {
    "aria-label": closeText,
    title: closeText,
    onClick: onClose,
    size: "xs",
    variant: "text",
    color: "inherit"
  }, /*#__PURE__*/React.createElement(_SM2.default, null)) : null));
});
var _default = exports.default = Alert;